import { PageBreadcrumbsWithLinks } from '@/components'
import { dashboardShellBreadcrumb } from '@/constants/adminPage'
import React, { lazy } from 'react'
import { useTranslation } from 'react-i18next'
import withSuspense from '@/helpers/suspense.helper'
import { PageBody, PageTitle, PageWrapper } from '@/components/PageWrapper'

const CustomPricingForm = withSuspense(lazy(() => import('./Components/CustomPricingForm')))

const ManageCustomPricing: React.FC = () => {
	const { t } = useTranslation()
	const pageTitle = t('Manage.CustomPricing.Heading', 'Custom Pricing')

	return (
		<>
			<PageBreadcrumbsWithLinks title={pageTitle} subNames={dashboardShellBreadcrumb(t('Manage.CustomPricing.Breadcrumb', 'Custom Pricing'))} />

			<PageWrapper>
				<PageTitle />
				<PageBody>
					<p className="mb-4 text-sm text-[hsl(var(--muted-foreground))]">
						{t(
							'Manage.CustomPricing.Intro',
							'Set the per-unit pricing admins use to build a custom subscription from a number of instances and users.'
						)}
					</p>
					<CustomPricingForm />
				</PageBody>
			</PageWrapper>
		</>
	)
}

export default ManageCustomPricing
